export const NewsDistributionToPortals = {
    None: 0,
    ThisPortal: 1,
    PortalsWhereIAmManager: 2,
    AllPortals: 3
};

export const contentTypeId = {
    None: 0,
    iDocumentDocument: 1,
    iCheckQuestionList: 2,
    iTaskReporterForm: 3,
    WebPage: 4,
    UNCPath: 5,
    iDataObject: 6,
    reportingReport: 7,
    iProcessCrossSection: 8
};

export const cookies = {
    StartPortal: "iPortal5StartPortal",
    RecentAndFavSelectedTab: "recentAndFavSelectedTab",
    iProva_LoginRedirect: "iProva_LoginRedirect",
    iQualifyTaskNoRefreshTill: "iQualifyTaskNoRefreshTill"
};

export const SystemUserIds = {
    AnonymousUser: "7C912665-1619-4483-9135-F00AC77A1AD6",
    Administrator: "2B84DC35-9184-46A0-AF90-36C41865A7D9"
};

export const SystemUserGroupIds = {
    AllUsers: "6C6C0F3F-0025-441B-840A-58622CE61E6F",
    LoggedInUsers: "E5BE19EE-9759-4FB4-9C59-DCE9D5FAFF34",
    Managers: "8FC79637-168D-402B-BEA5-C97CB83D38A7"
};

export const DateFormats = {
    DateFormat1: "dd-MM-yyyy",
    DateFormat2: "dd/MM/yyyy",
    DateFormat3: "dd.MM.yyyy",
    DateFormat4: "MM/dd/yyyy",
    DateFormat5: "yyyy-MM-dd",
    DateFormat6: "yyyy/MM/dd"
};

export const GlobalTargetNames = {
    WebPage: 0,
    Email: 1,
    UncPath: 2
};

export const SystemFilters = {
    Title: "-1",
    Type: "-2",
    Collections: "-3"
};

export enum HyperlinkType {
    Webpage,
    Unc,
    Email,
    ContentItem,
    Document
}

export enum SourceType {
    Favorite,
    NewsArticle,
    ToDo
}

export enum TaskSortOption {
    Created = "created",
    Deadline = "deadline",
    Important = "important"
}

export enum TaskPostPoneDialogOption {
    Week = "week",
    TwoWeeks = "twoWeeks",
    MaxDate = "maxDate",
    RemovePostponeDate = "removePostponeDate",
    CustomDate = "customDate"
}

export enum TaskFilterOption {
    My = "my",
    Postponed = "postponed",
    NotAssigned = "notAssigned"
}
export const ModulesIconLookup = {
    1: "description", //documents
    2: "assignment_turned_in", // question lists
    3: "assignment_late", //cases
    4: "web", // web pages,
    5: "mdi-server-network", //network location
    6: "credit_card", //objects - cards
    7: "assessment", //reporting
    8: "mdi-filter-outline" //cross section
};

export enum PrintDocumentParts {
    WholeDocument,
    Selection
}

export enum PrintDocumentWizardScreens {
    Templates,
    DownloadableTemplates,
    Document
}

export enum PrintHeaderOptions {
    Yes,
    No
}

export enum PrintingAction {
    StartPrinting = "doprint",
    PrintStatus = "getprintready"
}

export enum DiagramType {
    BarGraph = "bar_graph",
    PieChart = "pie_chart",
    Trendline = "trendline",
    MapWithLocations = "map",
    Heatmap = "heatmap",
    CalculatedScore = "calculated_score",
    WordCloudLabels = "word_cloud_labels",
    TopLabels = "top_labels",
    AnswerCount = "answer_count"
}

export enum ModuleManagement {
    Reporting = 14
}

export enum TaskListType {
    "User" = "user",
    "Team" = "team"
}

export enum LinkedDocumentType {
    Incoming = "incoming",
    Outgoing = "outgoing"
}

export enum BarChartType {
    Bar = "bar",
    StackedBar = "stackedBar",
    FullStackedBar = "fullStackedBar"
}

export enum LocationColorMode {
    green_to_red = "green_to_red",
    red_to_green = "red_to_green",
    blue = "blue"
}

export enum HyperlinkTargetFrameType {
    ContentFrame = 0,
    TopFrame = 1,
    PopUp = 2,
    NewWindow = 3
}

export enum ApiErrorType {
    InternalServerError = "internalServerError",
    Forbidden = "forbidden",
    BadRequest = "badRequest",
    NotFound = "notFound"
}

export enum DocumentCheckOutcome {
    ok,
    changes_needed,
    delegated,
    archived
}

export enum DocumentCheckOptions {
    can_remain = 1,
    changes_needed_administrators = 2,
    changes_needed_writers = 3,
    changes_needed_me = 4,
    archive = 5,
    delegate = 6
}

export enum CommentType {
    Reader = "reader",
    Reviewer = "reviewer",
    Writer = "writer",
    Personal = "personal"
}

export enum CommentState {
    New = "new",
    Accepted = "accepted",
    Fixed = "fixed",
    Rejected = "rejected"
}

export enum DirectedAt {
    Writers = "writers",
    Reviewers = "reviewers",
    Writers_And_Reviewers = "writers_and_reviewers"
}

export enum DocumentReviewState {
    not_started = "not_started",
    approved = "approved",
    rejected = "rejected"
}

export enum AnchorType {
    document = 0,
    paragraph = 1,
    process_page = 2,
    process_shape = 3,
    responsibility_matrix_shape = 4,
    objective_matrix_objective = 5
}

export const SubscriptionGroup = {
    CheckDocument: 3,
    ReadList: 4,
    ReviewDocument: 5,
    Cases: 9,
    HandleToDo: 10
};

export const iTaskSubscriptionType = {
    TodoItemAssignedToMe: 101,
    TodoItemAssignedToCaseOwner: 112
};

export enum DocumentVersionState {
    Published = "published",
    Review = "review",
    Draft = "draft",
    WaitingForPublication = "waiting_for_publication",
    Expired = "expired",
    LastArchived = "last_archived"
}

export enum SubscriptionType {
    Review = "101"
}

export enum PrintTemplateType {
    DocumentAdministrator = "document_administrator",
    Reader = "reader",
    Reviewer = "reviewer",
    PaperDistribution = "paper_distribution"
}

export enum DocumentCommentListMode {
    management = "management",
    review = "review",
    edit = "edit",
    read = "read"
}

export enum DocumentRoute {
    PublishedDocument = "published",
    ReviewDocument = "review",
    CheckDocument = "check",
    ReadDocument = "read"
}

export enum UserSubscriptionProperty {
    mail_frequency = "mail_frequency",
    show_in_messages_list = "show_in_messages_list"
}

export enum SnackBarTimeout {
    short = 2,
    medium = 3,
    long = 4,
    extra_long = 5
}

export enum FeatureType {
    iqualify_connector = "iQualifyConnector"
}

export enum SavingState {
    NotSaved,
    Saved,
    isSaving
}
